<template>
    <div class="dt-df">
        <input v-model="text" type="text" class="dt-df-search form-control" :placeholder="t(placeholder)" />
        <select v-model="records" class="dt-df-pagination form-control" v-if="pagination">
            <option v-for="_pagination in paginationValues" v-bind:value="_pagination">{{ _pagination }}</option>
        </select>
    </div>
</template>

<script>

    export default
    {
        model: {
            props: 'filter',
            event: 'update',
        },
        props: {
            filter: {
                default: null
            },
            placeholder: {
                default: 'Search',
            },
            paginationValues: {
                type: Array,
                default: () => { return [10, 50, 100, 300, 500]; }
            },
            pagination: {
                type: Boolean|Number,
                default: 50,
            },
            minChars: {
                type: Number,
                default: 3
            }
        },
        data() {
            return {
                text: '',
                records: null,
            };
        },
        mounted()
        {
            this.records = this.pagination;
        },
        watch:
        {
            text: {
                handler: function(val, oldVal)
                {
                    // if (this.minChars && (val.length < this.minChars)) {
                    //     return ;
                    // }

                    let result = {
                        search: this.text,
                        pagination: this.records,
                    };

                    this.$emit('update', result)
                }
            },
            records: {
                handler: function(val, oldVal) {
                    //prevent double request after init
                    if (oldVal === null) {
                        return;
                    }
                    let result = {
                        search: this.text,
                        pagination: this.records,
                    };

                    this.$emit('update', result)
                }
            }
        }
    }
</script>

<style >
    .dt-df {
        display: inline-block;
        width:100%;
        overflow: auto;
        position:relative;


    }
    .dt-df-search
    {
        float: left;
        width: 100%;
        padding-right: 60px;
    }

    .dt-df-pagination
    {
        position: absolute;
        width: 60px;
        float:right;
        right:0;
        top:0;
    }
</style>


// WEBPACK FOOTER //
// DataTableDefaultFilter.vue?4e7dd650